<template>
  <v-dialog content-class="history-dialog" v-model="dialog" @keydown.esc="close" persistent open-on-focus>
    <div class="d-container">
      <v-icon @click="close" class="d-close-button">mdi-close-circle</v-icon>
      <img v-if="backgroundSrc" :src="backgroundSrc" class="d-background" />
      <div class="d-body">
        <div class="header">
          <div class="header-title">{{ $t("PAD.order_history") }}</div>
        </div>
        <div class="content">
          <div v-for="(oh, index) in orderHistory" :key="index">
            <div v-if="oh.feed && oh.feed.items && oh.feed.items.length > 0" class="feed">
              <!-- <div class="order-time">{{ mUtils.toLocaleString(oh.time) }}</div> -->
              <div class="order-time">{{ oh.time }}</div>

              <div class="ordered-items">
                <v-row class="ordered-item" v-for="(oi, index) in oh.feed.items" :key="index">
                  <v-col cols="8" class="pa-6">
                    <div class="item-descr">
                      <div v-if="$store.state.descrIndex == 1 && oi.ord_descr1">{{ oi.ord_descr1 }}</div>
                      <div v-else-if="$store.state.descrIndex == 2 && oi.ord_descr2">{{ oi.ord_descr2 }}</div>
                      <div v-else>{{ oi.ord_descr }}</div>
                    </div>
                  </v-col>
                  <v-col cols="2" class="price-col">
                    <div v-if="oi.extended != 0" class="price-box">
                      <div class="price-value">{{ oi.extended | currency }}</div>
                    </div>
                  </v-col>
                  <v-col cols="2" class="qty-col">
                    <div class="qty-box">
                      <div class="qty-value">{{ oi.qty }}</div>
                    </div>
                  </v-col>
                </v-row>
              </div>
            </div>
          </div>

          <div class="order-total" v-if="orderHistory.length > 0">
            <span class="-title mr-4">{{ $t("total") }}</span
            ><span class="-value">{{ orderTotal | currency }}</span>
          </div>
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import mUtils from "@/modules/utils";

export default {
  data() {
    return {
      mUtils: mUtils,

      dialog: false,
      resolve: null,
      reject: null,

      refreshing: false,

      //orderHistory: undefined,
    };
  },

  computed: {
    backgroundSrc() {
      let _backgroundSrc = undefined;
      let image = this.$store.getters.padCartSchema?.background?.image;
      if (image && (image.fileSize > 0 || image.altUrl)) _backgroundSrc = image.downloadPath;

      return _backgroundSrc;
    },

    orderHistory() {
      let _orderHistory = [];
      let order = this.$store.state.Pad.order;
      if (order?.items) {
        order.items.forEach(item => {
          let feedItem = {
            ord_descr: item.descr,
            ord_descr1: item.descr1,
            ord_descr2: item.descr2,
            qty: item.qty,
            extended: item.extended,
          };
          let oh = _orderHistory.find(x => x.time == item.orderTime);
          if (oh) {
            oh.feed.items.push(feedItem);
          } else {
            oh = {
              time: item.orderTime,
              feed: { items: [feedItem] },
            };
            _orderHistory.push(oh);
          }
        });
      }
      //console.log("_orderHistory", _orderHistory);
      return _orderHistory;
    },

    orderTotal() {
      let _total = 0;
      let order = this.$store.state.Pad.order;
      if (order?.total >= 0) _total = order.total;

      return _total;
    },
  },

  methods: {
    open() {
      this.refreshing = false;
      this.dialog = true;

      //this.orderHistory = this.getOrderHistory();

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      if (this.resolve) this.resolve(true);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss">
.history-dialog {
  height: 90vh !important;
  width: 80vw !important;

  .d-container {
    background-color: white;

    height: 100%;
    width: 100%;

    position: relative;
    overflow: hidden;

    .d-close-button {
      position: absolute;
      top: 12px;
      right: 12px;
      z-index: 1;

      color: var(--v-primary-base);
      font-size: 2.4em;
    }

    .d-background {
      position: absolute;
    }

    .d-body {
      height: 100%;
      position: relative;

      .header {
        padding: 16px;
        height: 80px !important;

        display: flex;
        justify-content: center;

        .header-title {
          color: var(--v-primary-base);
          text-align: center;
          font-size: 2.5em;
          line-height: normal;
        }
      }

      .content {
        height: calc(100% - 80px - 20px);
        overflow: scroll !important;
        padding: 0px 64px;
        position: relative;

        .feed {
          margin-bottom: 8px;
          background-color: rgba(255, 255, 255, 0.25);
          border-radius: 15px;
          padding: 12px 0px 0px 12px;

          .order-time {
            color: var(--v-primary-base);
            //text-align: right;
          }

          .ordered-items {
            //padding-left: 4px;

            .ordered-item {
              .item-image {
                border-radius: 15px;
              }

              .item-descr {
                font-size: 1.2em;
                font-weight: bolder;
              }

              .item-total {
                font-size: 1.75em;
              }

              .price-col {
                display: flex;
                justify-content: flex-end;
                align-items: center;

                font-size: 1.2em;
              }

              .qty-col {
                display: flex;
                justify-content: center;
                align-items: center;

                .qty-box {
                  display: flex;
                  align-items: center;

                  height: 50px;
                  background-color: rgba(255, 255, 255, 0.75);
                  display: flex;
                  align-items: center;
                  height: 50px;
                  border-radius: 25px;
                  background-color: rgba(255, 255, 255, 0.75);

                  .qty-value {
                    min-width: 50px;
                    text-align: center;
                  }
                }
              }
            }
          }
        }

        .order-total {
          text-align: right;
          font-size: 1.4em;
          .-title {
            color: var(--v-primary-base);
          }

          .-value {
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>
